/* eslint-disable camelcase */
import brindeExtra from '../../images/clubs/subscription/brinde.png'
import logoCuradoria from '../../images/clubs/subscription/logo_curadoria.svg'
import logoIneditos from '../../images/clubs/subscription/logo_ineditos.svg'
import { formatPrice } from '@checkout/utils/formatter'

export const clubCuradoriaData = ( subscriptionPlans, curadoriaGift ) => ( {
  'club': 'Curadoria',
  'clubImage': logoCuradoria,
  'extraImage': brindeExtra,
  'prices': {
    'monthly': formatPrice( subscriptionPlans.find( plan => plan.category === 'Curadoria' && plan.type === 'Mensal' ).pricePerKit ),
    'yearly': formatPrice( subscriptionPlans.find( plan => plan.category === 'Curadoria' && plan.type === 'Anual' ).pricePerKit ),
  },
  'gift': curadoriaGift
} )


export const clubIneditosData = ( subscriptionPlans, ineditosGift ) => ( {
  'club': 'Inéditos',
  'clubImage': logoIneditos,
  'extraImage': brindeExtra,
  'prices': {
    'monthly': formatPrice( subscriptionPlans.find( plan => plan.category === 'Inéditos' && plan.type === 'Mensal' ).pricePerKit ),
    'yearly': formatPrice( subscriptionPlans.find( plan => plan.category === 'Inéditos' && plan.type === 'Anual' ).pricePerKit ),
  },
  'gift': ineditosGift
} )
